
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/otp",
      function () {
        return require("private-next-pages/quick-purchase/otp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-purchase/otp"])
      });
    }
  